import store from "@/store";
import { mapGetters, mapState } from "vuex";

export const organizationMixin = {
    computed: {
        ...mapState({
            user: state => state.user,
            roles: state => state.user.roles,
            restrict_to_orgs: state => state.user.restrict_to_orgs,
            all_organizations: state => state.organizations.all_organizations,
            aux_organizations: state => state.organizations.aux_organizations,
            primary_organizations: state => state.organizations.primary_organizations,
            disabled_organizations: state => state.organizations.disabled_organizations,
            active_organizations: state => state.organizations.active_organizations
        }),
        ...mapGetters({
            allOrganizations: "organizations/all_organizations",
            auxOrganizations: "organizations/aux_organizations",
            primaryOrganizations: "organizations/primary_organizations",
            restrictedToOrgs: "user/restrict_to_orgs"
        }),
        org_filters(){
            let org_options = [];
            org_options.push({
                'value': 'ALL_ALL',
                'text': 'All'
            });
            org_options.push({
                'value': 'ALL_PRIMARY',
                'text': 'Primary Orgs'
            });
            org_options.push({
                'value': 'ALL_AUX',
                'text': 'Auxilary Orgs'
            });
            return org_options;
        }
   },
   methods: {
      async getOrganizations(ward_id) {
        await store.dispatch("organizations/loadOrganizations", ward_id);
        },
     getContactOrganizationBreakdown(item, separator=',') {
        // fetch the details needed for a contact.
       let response = {
         primary: item.primary_organization,
         aux_orgs: [],
         aux_orgs_names: [],
         aux_count: 0,
         implicit_orgs: [],
         implicit_orgs_names: [],
         direct_aux_orgs: [],
         direct_aux_orgs_names: [],
         direct_aux_count: 0,
         implicit_count: 0,
         all_aux_orgs: [],
         all_aux_orgs_counts: 0,
         pretty_print: '',

       }
       // Find all orgs where the primary is subscribed to
       let primaryAux = this.allOrganizations.filter(x=>x.composite_orgs.includes(item.primary_organization));
       primaryAux.forEach(auxOrg => {
         response.aux_orgs.push(auxOrg.org_code);
         response.aux_orgs_names.push((auxOrg.disabled) ? `${auxOrg.text}[Disabled] [Implicit through Primary]`:`${auxOrg.text} [Implicit through Primary]`);
       });

       // Add organizations that a contact is directly assigned to.
       item.aux_organization.forEach(auxOrg=> {
         let filterOrg = this.allOrganizations.find(x=>x.org_code === auxOrg);
         if (filterOrg !== undefined){
           response.direct_aux_orgs.push(filterOrg.org_code);
           response.direct_aux_orgs_names.push((filterOrg.disabled) ? `${filterOrg.text}[Disabled] [Direct through Aux]`:`${filterOrg.text} [Direct through Aux]`);
         }

       })

       // Browse all implicit organizations
       item.aux_organization.forEach(auxOrg => {
         let filterOrg = this.allOrganizations.find(x=>x.org_code === auxOrg);
         let filterImplicitOrgs = this.allOrganizations.filter(x=>x.composite_orgs_expanded.includes(auxOrg));
         if (filterImplicitOrgs.length > 0) {
           filterImplicitOrgs.forEach(x => {
             if (!item.aux_organization.includes(x.org_code)) {
               response.implicit_orgs.push(x.org_code);
               response.implicit_orgs_names.push((x.disabled) ? `${x.text}[Disabled] [Implicit through ${filterOrg.text}]`:`${x.text} [Implicit through ${filterOrg.text}]`);
             }
           })
         }
       });
       let all_aux = response.aux_orgs_names.concat(response.direct_aux_orgs_names);
       all_aux = all_aux.concat(response.implicit_orgs_names);
       response.aux_count = item.aux_organization.length;
       response.implicit_count = response.implicit_orgs.length;
       response.aux_count = response.aux_orgs.length;
       response.direct_aux_count = response.direct_aux_orgs.length;
       response.all_aux_orgs = all_aux;

       response.all_aux_orgs_counts = all_aux.length;
       response.pretty_print = all_aux.join(separator);
       return response
     },
     alreadyInRestrictedOrgs(org) {
        let exists = false;
        this.allOrganizations.forEach(x=>{
          if(x.org_code == org){
            exists = true;
            return;
          }
        });
        return exists;
        },
     alreadyInCompositeOrgs(primary_org, org) {
        let exists = false;
        this.auxOrganizations.forEach(x=>{
          if (x.org_code === org && x.composite_orgs!==null) {
            exists =  x.composite_orgs.includes(primary_org);
            return;
          }
        });
        return exists;
        },
   },
};
